import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Container, AADUsers } from '../models/data.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  
  input:any;
  private _ComponentInput: BehaviorSubject<any> = new BehaviorSubject(this.input);

  initItems:Container[]=[];
  private menuItemsSource:BehaviorSubject<Container[]> = new BehaviorSubject(this.initItems);  
  menuItems = this.menuItemsSource.asObservable();

  initUtenti:AADUsers[]=[];
  private utentiSource:BehaviorSubject<AADUsers[]> = new BehaviorSubject(this.initUtenti);
  utenti = this.utentiSource.asObservable();

  constructor() { }

  fillMenuItems=(items:Container[])=>{    
    this.menuItemsSource.next(items);   
  }

  fetchUtentiAAD = (items:AADUsers[])=>{
    this.utentiSource.next(items);
  }

  
  public set ComponentInput(v : any) {
    this._ComponentInput.next(v);
  }
  
  
  public get ComponentInput() : any {
    return this._ComponentInput;
  }
  

}
